let assetPageOptions = {
    plotOptions: {
        radialBar: {
            dataLabels: {
                showOn: "always",
                name: {offsetY: -10, show: true, color: "#888", fontSize: "13px"},
                value: {
                    color: "#111", fontSize: "30px", show: true,
                    formatter: (val, struct) => {
                        const index = struct.globals.series.indexOf(Number(val))
                        let str = struct.globals.seriesNames[index];
                        return (str) ? str.substr(str.indexOf(':') + 1, 10) : ''
                    }
                },
                total: {
                    show: true,
                    label: '',
                    color: '#373d3f',
                    formatter: (w) => {
                        return (w.globals.series.join('') === '000') ? '' : w.globals.seriesNames[1];
                    }
                }
            }
        },

    },
    colors: ['#FF5252', '#2196F3', '#4CAF50'],
    labels: ['Просрочено', 'На руках', 'Выдано на'],
}

let employeeChartOptions = {
    chart: {stacked: true,},
    plotOptions: {bar: {horizontal: true,},},
    stroke: {width: 1, colors: ['#fff']},
    xaxis: {
        labels: {
            formatter: function (val) {
                return val + "Day"
            },
        },
    },
    yaxis: {title: {text: undefined},},
    tooltip: {
        y: {
            formatter: function (val) {
                return val + " Day"
            }
        }
    },
    fill: {opacity: 1},
    colors: ['#4CAF50', '#2196F3', '#FF5252'],
    legend: {position: 'top', horizontalAlign: 'left', offsetX: 40}
};

export default {assetPageOptions, employeeChartOptions}
